import React, { useEffect, useState } from "react";
import SimpleBar from "simplebar-react";
import { useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { ChartBarIcon, ChevronRightIcon, XIcon } from "@heroicons/react/solid";
import {
  Nav,
  Badge,
  Image,
  Button,
  Navbar,
  Collapse,
  Col,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import { Routes } from "routes";
import ProfilePicture from "assets/img/team/profile-picture-3.jpg";
import {
  FaRegAddressCard,
  FaShop,
  FaUsersRays,
  FaWallet,
} from "react-icons/fa6";
import {
  MdCampaign,
  MdOutlineMonitorHeart,
  MdSupervisorAccount,
} from "react-icons/md";
import {
  RiContactsBook3Fill,
  RiScissorsCutLine,
  RiShareForwardFill,
} from "react-icons/ri";
import { MdOutlineSettingsInputAntenna } from "react-icons/md";
import { BiLogOutCircle } from "react-icons/bi";
import logo from "../../src/assets/img/Telkosh.png";
import LogoIcon from "../assets/img/icons/icon.png";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useHistory } from "react-router-dom";
import { ImInsertTemplate } from "react-icons/im";
import {
  TbBrandWhatsappFilled,
  TbLayoutDashboardFilled,
  TbMessageChatbot,
  TbUsersPlus,
} from "react-icons/tb";
import { PiChatsCircleFill } from "react-icons/pi";
import { FaUserEdit } from "react-icons/fa";

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: "btn btn-secondary me-3",
      cancelButton: "btn btn-gray",
    },
    buttonsStyling: false,
  })
);

function Sidebar() {
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;

  const [show, setShow] = useState(false);
  const [collapsedItems, setCollapsedItems] = useState([pathname]);
  const showClass = show ? "show" : "";

  const [userObject, setUserObject] = useState(null);
  const [userType, setUserType] = useState(null);
  const [token, setToken] = useState(null);
  const [permissionMap, setPermissionMap] = useState(null);

  //getting data
  const rawToken = localStorage.getItem("TOKEN");

const parsedUser = React.useMemo(() => {
  try {
    return rawToken ? JSON.parse(rawToken) : null;
  } catch {
    return null;
  }
}, [rawToken]);


  useEffect(() => {
    if (!parsedUser) {
      goOut();
      return;
    }
  
    setUserObject(parsedUser);
    setUserType(parsedUser.user_type || null);
    setToken(parsedUser.token || null);
  
    const features = Array.isArray(parsedUser.features)
      ? parsedUser.features
      : [];
  
    const permissionMap = {};
    features.forEach((feature) => {
      if (feature?.name) {
        permissionMap[feature.name] = feature;
      }
    });
  
    setPermissionMap(permissionMap);
  }, [parsedUser]);

  const onCollapse = () => setShow(!show);

  const onPermissionNavItemCollapse = (itemKey) => {
    const isCollapsed = collapsedItems.some((item) => item.includes(itemKey));
    const newCollapsedItems = isCollapsed
      ? collapsedItems.filter((item) => !item.includes(itemKey))
      : [...collapsedItems, itemKey];
    setCollapsedItems(newCollapsedItems);
  };

  const Logout = async () => {
    const textMessage = "Are you sure you want to log out?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "question",
      title: "Confirm Exit",
      text: textMessage,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Yes",
    });

    if (result.isConfirmed) {
      goOut();
    }
  };

  const goOut = () => {
    history.push(Routes.Presentation.path);
    localStorage.removeItem("TOKEN");
  };

  const CollapsablePermissionNavItem = (props) => {
    const {
      eventKey,
      title,
      icon: PermissionNavItemIcon,
      children = null,
    } = props;
    const isOpened = collapsedItems.some((item) => item.includes(eventKey));
    
    const isActive = React.Children.toArray(children).some(
      (child) => {
        if (!React.isValidElement(child)) return false;
        
        const path = child.props.link;
        return pathname.startsWith(path);
      }
    );
    
    const NavItemClassName = (isActive && !isOpened) ? "active" : '';

    // Helper to check if a child PermissionNavItem has permission
    const childHasPermission = React.Children.toArray(children).some(
      (child) => {
        if (!React.isValidElement(child)) return false;

        const feature = child.props.feature || child.props.title;
        const action = child.props.action || "read";
        return permissionMap?.[feature]?.[action];
      }
    );

    if (!childHasPermission) return null;

    return (
      <Nav.Item className={NavItemClassName}>
        <Nav.Link
          onClick={() => onPermissionNavItemCollapse(eventKey)}
          aria-expanded={isOpened}
          aria-controls={eventKey}
          className="d-flex justify-content-between align-items-center"
        >
          <span>
            <span className="sidebar-icon">
              <PermissionNavItemIcon className="icon icon-xs me-2" />
            </span>
            <span className="sidebar-text">{title}</span>
          </span>
          <span className="link-arrow">
            <ChevronRightIcon className="icon icon-xxs" />
          </span>
        </Nav.Link>
        <Collapse in={isOpened} className="multi-level">
          <div id={eventKey}>{children}</div>
        </Collapse>
      </Nav.Item>
    );
  };

  const PermissionNavItem = (props) => {
    const {
      title,
      action = "read",
      link,
      target,
      icon: NavItemIcon,
      image,
      badgeText,
      badgeBg,
      badgeColor = "white",
    } = props;
    const classNames = badgeText
      ? "d-flex align-items-center justify-content-between"
      : "";
    const NavItemClassName = (link === pathname || pathname.startsWith(link)) ? "active" : "";

    const hasPermission = permissionMap?.[title]?.[action] === true;

    if (!hasPermission) return null;
    return (
      <Nav.Item className={NavItemClassName} onClick={() => setShow(false)}>
        <Nav.Link as={Link} to={link} target={target} className={classNames}>
          <span>
            {NavItemIcon && (
              <span className="sidebar-icon">
                <NavItemIcon className="icon icon-xs me-2" />
              </span>
            )}

            {image ? (
              <Image
                src={image}
                width={20}
                height={20}
                className="sidebar-icon svg-icon"
              />
            ) : null}

            {!show && !NavItemIcon && !image ? (
              <span className="sidebar-text-contracted">{title[0]}</span>
            ) : null}

            <span className="sidebar-text">{title}</span>
          </span>

          {badgeText ? (
            <Badge
              pill
              bg={badgeBg}
              text={badgeColor}
              className="badge-sm notification-count"
            >
              {badgeText}
            </Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  // const localshortUrl = `http://localhost:3001?token=${token}`;
  // const shortUrl = `${process.env.REACT_APP_SHORT_URL_PORT}?token=${token}`

  // console.log(shortUrl);
  // console.log(localshortUrl);

  if (!userObject || !permissionMap) {
    return null; // or loader
  }  

  return (
    <>
      <Navbar
        as={Col}
        xs={12}
        expand={false}
        collapseOnSelect
        variant="dark"
        className="navbar-theme-primary px-4 d-lg-none"
      >
        <Navbar.Brand
          as={Link}
          to={Routes.Dashboard.path}
          className="me-lg-5"
        >
          <Image
            src={LogoIcon}
            alt="logo-icon"
            width={40}
            height={40}
            className="sidebar-icon svg-icon"
          />
        </Navbar.Brand>
        <div className="d-flex align-items-center">
          <Navbar.Toggle as={Button} onClick={onCollapse}>
            <span className="navbar-toggler-icon" />
          </Navbar.Toggle>
        </div>
      </Navbar>

      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar
          className={`${showClass} sidebar d-lg-block text-white collapse`}
        >
          <div className="sidebar-inner p-3" style={{ minHeight: "80vh" }}>
            <div className="user-card d-flex d-md-none justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="avatar-lg me-4">
                  <Image
                    src={ProfilePicture}
                    className="card-img-top rounded-circle border-white"
                  />
                </div>
                <div className="d-block">
                  <h5 className="mb-3">Hi, {userObject.name}</h5>
                  <Button
                    as={Button}
                    variant="secondary"
                    size="sm"
                    onClick={Logout}
                    className="d-inline-flex align-items-center"
                  >
                    <BiLogOutCircle className="icon icon-xs me-1" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link
                className="collapse-close d-md-none"
                onClick={onCollapse}
              >
                <XIcon className="icon icon-xs" />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
            <div
                  style={{
                    maxWidth: "210px",
                    background: "#ffffff66",
                    borderRadius: "10px",
                    padding: "10px",
                    marginBottom: "20px",
                  }}
                >
                  <Image src={logo} alt="logo-telKosh" />
                </div>

                <PermissionNavItem
                title="Dashboard"
                icon={TbLayoutDashboardFilled}
                link={Routes.Dashboard.path}
              />

              <CollapsablePermissionNavItem
                eventKey="reports"
                title="Reports"
                icon={ChartBarIcon}
              >
                <PermissionNavItem
                  title="Campaign Analytics"
                  link={Routes.CampaignAnalytics.path}
                />
                <PermissionNavItem
                  title="FailOver Analytics"
                  link={Routes.FailOverAnalytics.path}
                />
                <PermissionNavItem
                  title="SMS Reports"
                  link={Routes.SMSReports.path}
                />
                <PermissionNavItem
                  title="WhatsApp Reports"
                  link={Routes.WhatsAppReports.path}
                />
                <PermissionNavItem
                  title="RCS Reports"
                  link={Routes.RCSReports.path}
                />
                {/* <PermissionNavItem
                  title="View CDR"
                  link={Routes.ViewCDR.path}
                />
                <PermissionNavItem
                  title="Download CDR"
                  link={Routes.DownloadCentre.path}
                /> */}
              </CollapsablePermissionNavItem>

              {userType !== "enterprise_user" &&
                userType !== "enterprise_reporting_user" && (
                  <PermissionNavItem
                    title="User Management"
                    icon={FaUserEdit}
                    link={Routes.UserManagement.path}
                  />
                )}

              {(userType === "super_admin" ||
                userType === "admin" ||
                userType === "enterprise" ||
                userType === "enterprise_user" ||
                userType === "enterprise_reporting_user") && (
                <CollapsablePermissionNavItem
                  eventKey="Connectivity Setup"
                  title="Connectivity Setup"
                  icon={MdSupervisorAccount}
                >
                 {userType !== "enterprise_reporting_user" && (
                    <PermissionNavItem
                      title="SMS SMPP Account"
                      link={Routes.SMSSMPPAccount.path}
                    />
                  )}
                  {(userType === "super_admin" || userType === "admin") && (
                    <PermissionNavItem
                      title="SMSC Registration"
                      link={Routes.SMSCRegistration.path}
                    />
                  )}
                  {(userType === "super_admin" || userType === "admin") && (
                    <PermissionNavItem
                      title="SMSC Rates"
                      link={Routes.SMSCRates.path}
                    />
                  )}
                  {(userType === "super_admin" || userType === "admin") && (
                    <PermissionNavItem
                      title="WA BSPs"
                      link={Routes.WABSPs.path}
                    />
                  )}
                  {(userType === "super_admin" || userType === "admin") && (
                    <PermissionNavItem
                      title="WA Rates"
                      link={Routes.WARates.path}
                    />
                  )}
                  {(userType === "super_admin" || userType === "admin") && (
                    <PermissionNavItem
                      title="RCS BSPs"
                      link={Routes.RCSBSPs.path}
                    />
                  )}
                 {(userType === "super_admin" || userType === "admin") && (
                    <PermissionNavItem
                      title="RCS Rates"
                      link={Routes.RCSRates.path}
                    />
                  )}
                </CollapsablePermissionNavItem>
              )}

              {(userType === "super_admin" || userType === "admin" || userType === "enterprise" ) && (
                <PermissionNavItem
                title="SenderID Registration"
                icon={FaRegAddressCard}
                link={Routes.SenderIDRegistration.path}
              />
              )}

              {userType !== "customer relationship manager" && (
                <CollapsablePermissionNavItem
                  eventKey="mapping"
                  title="Mapping"
                  icon={TbUsersPlus}
                >
                   <PermissionNavItem
                    title="Routes Mapping"
                    link={Routes.RoutesMapping.path}
                  />
                  <PermissionNavItem
                    title="Reporting User"
                    link={Routes.ReportingUser.path}
                  />
                </CollapsablePermissionNavItem>
              )}

{(userType === "super_admin" || userType === "admin") && (
                <PermissionNavItem
                  title="Vendor Management"
                  icon={FaShop}
                  link={Routes.VendorManagement.path}
                />
              )}

              {(userType === "super_admin" || userType === "admin") && (
                <PermissionNavItem
                  title="Routing"
                  link={Routes.Routing.path}
                  icon={FaUsersRays}
                />
              )}

              {(userType === "super_admin" || userType === "admin") && (
                <CollapsablePermissionNavItem
                  eventKey="wallet"
                  title="Wallet"
                  icon={FaWallet}
                >
                  <PermissionNavItem
                    title="Enterprise Wallet"
                    link={Routes.EnterpriseWallet.path}
                  />
                  <PermissionNavItem
                    title="Vendor Wallet"
                    link={Routes.VendorWallet.path}
                  />
                </CollapsablePermissionNavItem>
              )}
              {/* enterprise wallet */}
              {userType === "enterprise" && (
                <PermissionNavItem
                  title="Enterprise Wallet"
                  icon={FaWallet}
                  link={Routes.EnterpriseWallet.path}
                />
              )}

              {(userType === "super_admin" || userType === "admin") && (
                <PermissionNavItem
                  title="Channel Testing"
                  icon={MdOutlineSettingsInputAntenna}
                  link={Routes.ChannelTesting.path}
                />
              )}

              <PermissionNavItem
                title="Templates"
                icon={ImInsertTemplate}
                link={Routes.Templates.path}
              />

              {userType === "enterprise_user" && (
                <div class="nav-item">
                  <a
                    class="nav-link"
                    href={`${process.env.REACT_APP_SHORT_URL_PORT}?token=${token}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="d-flex align-items-center">
                      <span class="sidebar-icon me-3">
                        <RiScissorsCutLine className="icon icon-xs"/>
                      </span>
                      <span class="d-flex align-items-center justify-content-between w-100">
                        <span class="sidebar-text">Short URLs</span>
                        <RiShareForwardFill className="icon icon-xxs" />
                      </span>
                    </span>
                  </a>
                </div>
              )}

              {(userType === "enterprise" ||
                userType === "enterprise_user") && (
                <PermissionNavItem
                  title="Contact List"
                  icon={RiContactsBook3Fill}
                  link={Routes.ContactList.path}
                />
              )}

              <PermissionNavItem
                title="Campaign"
                icon={MdCampaign}
                link={Routes.Campaign.path}
              />

              {(userType === "super_admin" || userType === "admin") && (
                <CollapsablePermissionNavItem
                  eventKey="monitor"
                  title="System Monitor"
                  icon={MdOutlineMonitorHeart}
                >
                  <PermissionNavItem
                    title="ESME List"
                    link={Routes.ESMEList.path}
                  />
                  <PermissionNavItem
                    title="SMSC List"
                    link={Routes.SMSCList.path}
                  />
                </CollapsablePermissionNavItem>
              )}
              {/* ------- */}
              {userType === "enterprise" && (
                <PermissionNavItem
                  title="ChatBot"
                  icon={TbMessageChatbot}
                  link={Routes.ChatBot.path}
                />
              )}

              {userType === "enterprise" && (
                <PermissionNavItem
                  title="WA Profiles"
                  icon={TbBrandWhatsappFilled}
                  link={Routes.WAProfiles.path}
                />
              )}

              {/* <CollapsablePermissionNavItem eventKey="configurations" title="Configurations" icon={BsClipboardData}>
                  <PermissionNavItem title="DLR Webhook" link={Routes.ConfigDLRWebhook.path} />
                  <PermissionNavItem title="API Token" link={Routes.ConfigAPIToken.path} />
                  <PermissionNavItem title="API Docs" link={Routes.ConfigAPIDocs.path} />
                </CollapsablePermissionNavItem> */}

              {userType === "enterprise" && (
                <div class="nav-item">
                  <a
                    class="nav-link"
                    href={`${process.env.REACT_APP_CHATS_PORT}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="d-flex align-items-center">
                      <span class="sidebar-icon me-3">
                        <PiChatsCircleFill className="icon icon-xs"/>
                      </span>
                      <span class="d-flex align-items-center justify-content-between w-100">
                        <span class="sidebar-text">Chats</span>
                        <RiShareForwardFill className="icon icon-xxs" />
                      </span>
                    </span>
                  </a>
                </div>
              )}
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
}

export default React.memo(Sidebar);
